import styled from 'styled-components';
import { colors, fonts } from 'assets/styled/tokens';

export const StyledInputWrapper = styled.div<{ width?: string }>`
  width: ${({ width }) => width || 'auto'};
  position: relative;
  background: ${colors.white};
  display: flex;
  align-items: center;

  & > svg {
    position: absolute;
    z-index: 1;
    left: 9px;
    pointer-events: none;
  }
`;

export const StyledInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.35rem 0.85rem 0.35rem 24px;
  font-size: 12px;
  line-height: 16px;
  font-family: ${fonts.family.text};
  border: 1px solid ${colors.lightGray};
  border-radius: 3px;
  background-color: white;
  color: ${colors.gray};
  outline: none;
  cursor: pointer;

  &:disabled {
    background-color: ${colors.pampas};
    cursor: not-allowed;
    color: ${colors.mediumGray};
  }

  &:focus {
    border-color: ${colors.gray};
  }
`;

export const StyledDropdown = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  top: 36px;
  left: 0;
  z-index: 100;
  background: ${colors.white};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  border-radius: 0 0 3px 3px;
`;

export const StyledDropdownColumns = styled.div`
  display: flex;
  gap: 0;
`;

export const StyledColumnLabel = styled.div`
  font-size: 11px;
  font-family: ${fonts.family.text};
  color: ${colors.mediumGray};
  text-align: center;
  padding: 6px 0 4px;
  border-bottom: 1px solid ${colors.lightGray};
`;

export const StyledTimeColumn = styled.div`
  width: 64px;
  height: 200px;
  overflow-y: auto;

  & + & {
    border-left: 1px solid ${colors.lightGray};
  }

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.lightGray};
    border-radius: 2px;
  }
`;

export const StyledTimeOption = styled.div<{ selected: boolean }>`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-family: ${fonts.family.text};
  cursor: pointer;
  color: ${({ selected }) => (selected ? colors.white : colors.gray)};
  background: ${({ selected }) => (selected ? colors.primary : 'transparent')};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};

  &:hover {
    background: ${({ selected }) => (selected ? colors.primary : colors.pampas)};
  }
`;

export const StyledDropdownFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  border-top: 1px solid ${colors.lightGray};

  button {
    font-size: 12px;
    line-height: 14px;
  }
`;
